export const VENDORS_GETALL_PENDING = "VENDORS_GETALL_PENDING";

export const VENDORS_GETALL = "VENDORS_GETALL";

export const VENDORS_GETALL_SUCCESS = "VENDORS_GETALL_SUCCESS";

export const VENDORS_GETALL_ERROR = "VENDORS_GETALL_ERROR";

export const VENDORS_CHECK_DUP_NAME = "VENDORS_CHECK_DUP_NAME";

export const VENDORS_SAVE = "VENDORS_SAVE";

export const VENDORS_SAVE_PENDING = "VENDORS_SAVE_PENDING";

export const VENDORS_SAVE_ERROR = "VENDORS_SAVE_ERROR";

export const VENDORS_SAVE_SUCCESS = "VENDORS_SAVE_SUCCESS";

export const VENDOR_EDIT_REQUEST = "VENDOR_EDIT_REQUEST";

export const VENDOR_EDIT_REQUEST_SUCCESS = "VENDOR_EDIT_REQUEST_SUCCESS";
